import { getEntityRef } from "@client/content/lib/helper";
import { type RootContainerProps } from "@client/content/types";
import { connectCustom } from "@client/lib/misc";
import { TargetSelector, getSettingSelector, getSettingValueSelector } from "@client/selectors";
import { type AppState } from "@client/types";
import * as React from "react";
import { setModalVisible } from "./actions";
import Component, { type OptInFormComponentActionProps, type OptInFormComponentMapProps } from "./component";

const makeMapStateToProps = () => {
  const displaySelector = getSettingValueSelector(TargetSelector.Entity, "display");
  const buttonInnerHorizontalAlignSelector = getSettingSelector(
    TargetSelector.Entity,
    "innerHorizontalAlign",
    "button"
  );

  return (state: AppState, props: RootContainerProps): OptInFormComponentMapProps => {
    return {
      ...props,
      buttonsAlign: buttonInnerHorizontalAlignSelector(state, props),
      display: displaySelector(state, props)
    };
  };
};

const mapDispatchToProps = (dispatch, props: RootContainerProps): OptInFormComponentActionProps => ({
  showModal: (e: React.MouseEvent<any>) => {
    e.preventDefault();
    dispatch(setModalVisible(getEntityRef(props), true));
  }
});

export default connectCustom(makeMapStateToProps, mapDispatchToProps)(Component);
